import { render, staticRenderFns } from "./ConfirmationSponsor.vue?vue&type=template&id=4c646827&"
import script from "./ConfirmationSponsor.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c646827')) {
      api.createRecord('4c646827', component.options)
    } else {
      api.reload('4c646827', component.options)
    }
    module.hot.accept("./ConfirmationSponsor.vue?vue&type=template&id=4c646827&", function () {
      api.rerender('4c646827', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/Modal/ConfirmationSponsor.vue"
export default component.exports